const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths
    .filter((width) => width <= image["width"])
    .map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    })
    .join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(
    previewImage,
    [165, 360, 533, 720, 940, 1066]
  );
  newImage.loading = "lazy";
  return newImage;
};

const checkSwatches = () => {
  document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
    const productHandle = wrapper.dataset.product;

    // A merchant colour name such as Ecru is not necessarily a CSS colour.
    // Preserve the real option name instead of drawing an empty colour dot.
    wrapper.querySelectorAll("label.color-swatch").forEach((label) => {
      const colour = label.style.getPropertyValue("--swatch-color").trim();
      label.classList.toggle("color-swatch--named", !CSS.supports("color", colour));
    });

    // Check for 'book-no-show' tag in the product data
    jQuery.getJSON(
      window.Shopify.routes.root + `products/${productHandle}.js`,
      function (product) {
        const hasBookNoShowTag = product.tags.includes("book-no-show");

        if (hasBookNoShowTag) {
          // Hide the 'Add to Cart' button and show 'View Product' link
          const addToCartButton = wrapper.querySelector(".card__add-to-cart");
          const viewProductButton = document.createElement("a");
          viewProductButton.href = product.url;
          viewProductButton.className = "view-product-button button--primary";
          viewProductButton.textContent = "View Product";

          if (addToCartButton) {
            addToCartButton.replaceWith(viewProductButton);
          }
        }
      }
    );

    wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
      input.addEventListener("click", (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;

        if (event.currentTarget.checked && primaryImage) {
          wrapper
            .querySelector(".js-color-swatches-link")
            .setAttribute("href", event.currentTarget.dataset.variantLink);

          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper
              .querySelector('.card__add-to-cart button[name="add"]')
              .setAttribute("aria-disabled", false);
            wrapper
              .querySelector('.card__add-to-cart button[name="add"] > span')
              .classList.remove("hidden");
            wrapper
              .querySelector(
                '.card__add-to-cart button[name="add"] .sold-out-message'
              )
              .classList.add("hidden");
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
              event.currentTarget.dataset.variantId;
          }

          const currentColor = event.currentTarget.value;

          jQuery.getJSON(
            window.Shopify.routes.root + `products/${handleProduct}.js`,
            function (product) {
              const variant = product.variants.filter(
                (item) =>
                  item.featured_media != null &&
                  item.options.includes(currentColor)
              )[0];

              if (variant) {
                const newPrimaryImage = createImageElement(
                  variant["featured_media"],
                  primaryImage.className,
                  primaryImage.sizes,
                  product.title
                );

                if (newPrimaryImage.src !== primaryImage.src) {
                  let flag = false;
                  if (secondaryImage) {
                    const secondaryImagePathname = new URL(secondaryImage.src)
                      .pathname;
                    const newPrimaryImagePathname = new URL(newPrimaryImage.src)
                      .pathname;

                    if (secondaryImagePathname == newPrimaryImagePathname) {
                      primaryImage.remove();
                      secondaryImage.classList.remove("media--second");
                      secondaryImage.classList.add("media--first");
                      flag = true;
                    }
                  }
                  if (flag == false) {
                    // Load the new variant image BEFORE swapping so the card never
                    // flashes its IP backdrop with no product image. Keep the old
                    // image fully visible until the new one is ready, then cross-fade.
                    newPrimaryImage.loading = "eager";
                    const swapIn = function () {
                      primaryImage.replaceWith(newPrimaryImage);
                      newPrimaryImage.animate(
                        { opacity: [0, 1] },
                        { duration: 200, easing: "ease-in" }
                      );
                      if (secondaryImage) {
                        secondaryImage.remove();
                      }
                    };
                    if (newPrimaryImage.complete && newPrimaryImage.naturalWidth) {
                      swapIn();
                    } else {
                      newPrimaryImage.addEventListener("load", swapIn, { once: true });
                      newPrimaryImage.addEventListener("error", swapIn, { once: true });
                    }
                  }
                }
              }
            }
          );
        }
      });
    });
  });
};

function colorSwatches() {
  checkSwatches();

  document.addEventListener("shopify:section:load", function () {
    checkSwatches();
  });
}

(function () {
  colorSwatches();
})();
